import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Navbar from "./Navbar";

export const ListLayout = ({ children }) => (
  <DashboardLayout>
    <Navbar />
    {children}
  </DashboardLayout>
);

export const Layout = ({ children, lg = 8 }) => (
  <DashboardLayout>
    <Navbar />
    <MDBox py={3} mb={20}>
      <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
        <Grid item xs={12} lg={lg}>
          <Card sx={{ height: "100%" }}>
            <MDBox p={3}>{children}</MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  </DashboardLayout>
);

export const InboundLayout = ({ children, lg = 8 }) => (
  <DashboardLayout>
    <Navbar />
    <MDBox py={3} mb={20}>
      <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
        <Grid item xs={12} lg={lg}>
          {children}
        </Grid>
      </Grid>
    </MDBox>
  </DashboardLayout>
);

export const InboundHeaderCard = ({ children }) => (
  <Card sx={{  height: "100%", marginBottom: "1rem", p: 3 }}>{children}</Card>
);

export const SetupHeaderCard = ({ children }) => (
  <Card sx={{  height: "100%", marginBottom: "1rem", p: 3 }}>{children}</Card>
);

export const TableCard = ({ children,sx }) => (
  <Card sx={{borderRadius:"2px",...sx, backgroundColor:"inherit",boxShadow:"0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.02), 0px 1px 10px 0px rgba(0,0,0,0.2)"}}>{children}</Card>
);

//background:"linear-gradient(195deg, #f9f9fb, #f1efff)"